import { FIREBASE_FUNCTIONS_HOST } from 'utils/env';

const url = (path: string) => `${FIREBASE_FUNCTIONS_HOST}/${path}`;

export const getIncidentUrl = () => url('incidents-https-getIncident');
export const getDownloadIncidentUrl = () =>
  url('incidents-https-downloadIncident');
